/* eslint-disable react/jsx-no-useless-fragment */
import React, { useState } from 'react';

import styles from './Collapse.module.css';

const Collapse = ({ title, children }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const toggleIsCollapsed = () => setIsCollapsed((prevState) => !prevState);
  const icon = isCollapsed ? 'far fa-chevron-right' : 'far fa-chevron-down';

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <span>{title}</span>
        <button
          type="button"
          className="naked-button"
          onClick={toggleIsCollapsed}
        >
          <i className={icon} />
        </button>
      </div>
      {!isCollapsed && <>{children}</>}
    </div>
  );
};

export default Collapse;
